export default __webpack_public_path__ + "static/media/accessories.845b7561.jpg";